import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { MouService } from '../../../shared/navigation/mou-ack/mou.service';
import { GlobalVariablesService } from '../../../services/global-variables.service';
import { EventMouVm } from '../../../shared/generated/Administration/Models/Events/EventMouVm';
import { UserJsVm } from '../../../shared/generated/Administration/Models/User/JavaScript/UserJsVm';
import { SecurityService } from '../../../core/security/security.service';

@Component({
    selector: 'pcg-user-mou',
    templateUrl: './user-mou.component.html',
    styleUrls: ['./user-mou.component.scss'],
    standalone: false
})
export class UserMouComponent implements OnInit {
	
	user: UserJsVm;

	userId: number;
	eventId: number;
	fullName: string;	
	eventName: string;
	mouLanguage: string;
	mouAcknowledgedOn: string;
	dateMouAcknowledged: string;

	constructor(
		private mouService: MouService
		, private activatedRoute: ActivatedRoute
		, private gvs: GlobalVariablesService
		, private sec: SecurityService
	) { }

	ngOnInit(): void {
		this.userId = this.activatedRoute.snapshot.params.id;
		this.sec.user$.subscribe(user => { 
			this.user = user; 
			this.eventId = user?.currentEventId;
			this.gvs.userName.set(user?.fullName!);
		}); 
		this.getMouLanguage();
	}

	getMouLanguage(): void {
        this.mouService.getMOULanguageByEventAndUser(this.eventId, this.userId)
            .subscribe((vm: EventMouVm) => {
                this.mouLanguage = vm.memorandumLanguage!;
                this.dateMouAcknowledged = vm.dateMouAcknowledgedString!; 
                if (
                    this.dateMouAcknowledged === '' 
                    || this.dateMouAcknowledged === null
                ) { this.mouAcknowledgedOn = 'You have not acknowledged this MOU for ' + vm.eventName; }
                else { this.mouAcknowledgedOn = 'You acknowledged this MOU for ' + vm.eventName + ' on ' + this.dateMouAcknowledged; }
            }
        );
	}
}
